import React from "react";
import classNames from "classnames";
import { Card as BootstrapCard } from "react-bootstrap";
import PropTypes from "prop-types";

const Card = ({ className, children, rounded, onClick }) => (
  <BootstrapCard
    className={classNames(
      "mydpd-card",
      rounded && "mydpd-card-rounded",
      className
    )}
    onClick={onClick}
  >
    {children}
  </BootstrapCard>
);

Card.defaultProps = {
  className: "",
  children: null,
  rounded: true,
};

Card.propTypes = {
  ...BootstrapCard.propTypes,
  children: PropTypes.node,
  className: PropTypes.string,
  rounded: PropTypes.bool,
};

export default Card;
